import theme from '@css/theme';
import { Flex } from '@ui-library/misc';
import { Body } from '@ui-library/typography';
import styled from 'styled-components';
import { is, isNot } from 'typescript-styled-is';

export const EmptyContainer = styled(Flex).attrs({
  alignItems: 'center',
})<{ textLeft?: boolean }>`
  padding: 4rem;
  background-color: #ffffff;
  border-radius: 8px;

  ${is('textLeft')`
    flex-direction: row-reverse;
    justify-content: space-between;
    
  `}
  ${isNot('textLeft')`
    > :nth-child(2) {
      margin-left: 4rem;
    }
  `}
`;

export const TextContainer = styled(Flex).attrs({
  flexDirection: 'column',
})`
  max-width: 500px;
`;

export const BodyText = styled(Body)`
  color: ${theme.color.neutral2};
  margin-top: 0.5rem;
`;

export const SvgContainer = styled.div`
  min-width: 200px;
  > svg {
    width: 100%;
    height: 100%;
  }
`;

export const CTAContainer = styled.div`
  margin-top: 1.5rem;
`;
